<div fxLayout="column" fxLayoutGap="20px" class="connect-choose-method-container">
  <div class="decision-flow-header">
    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center">
      <img src="/assets/images/hospitable.png" alt="Hospitable Logo" class="logo hospitable-logo" />
      <img src="/assets/iconography/connect.svg" class="connect-img" />
      <img src="/assets/images/connected-accounts/booking.svg" alt="Booking.com Logo" class="logo bdc-logo" />
    </div>
    <p class="header-description">
      Keep calendar and pricing synchronized across multiple channels, avoid double bookings, and save time with
      automated messaging by managing all of your reservations in one place.
    </p>
  </div>

  <div fxLayout="row" fxLayout.xs="column" fxLayoutGap="20px" class="options-container">
    <mat-card class="option-card option-quick-setup" fxFlex>
      <h2>Quick Setup Wizard</h2>
      <p class="time-estimate">2 minutes</p>
      <p>
        Hospitable.com will request an authentication token, stored only during the connection with state-of-the-art
        encryption.
      </p>
      <button
        class="fw connect-button bg-booking"
        mat-flat-button
        [routerLink]="['/accounts/new/booking-quick-setup/login']">
        <span>Quick Setup</span>
      </button>
    </mat-card>

    <mat-card class="option-card" fxFlex>
      <h2>Manual Connection</h2>
      <p class="time-estimate">5-10 minutes</p>
      <p>
        We will not require an authentication, but you will be redirected to Booking.com for part of the connection
        process.
      </p>
      <button
        class="fw connect-button button__secondary"
        mat-flat-button
        [routerLink]="['/accounts/new/booking/requirements']">
        <span>Manual Connection</span>
      </button>
    </mat-card>
  </div>
</div>
